<template>
  <b-overlay :show="usersLoading" class="rounded" variant="transparent">
    <template #overlay>
      <b-img
        width="100"
        :src="require('@/assets/img/brand/loader.gif')"
        alt=""
      />
    </template>
    <div class="card shadow p-3">
      <div class="card-header border-0">
        <div class="row align-items-center">
          <div class="col">
            <h3 class="mb-0">
              {{ title }}
            </h3>
          </div>
        </div>
      </div>

      <b-row>
        <b-col md="2">
          <b-form-select
            v-model="filter.per_page"
            :options="[5, 10, 20, 100]"
            size="sm"
            class="mt-2"
            @input="debouncedGetAnswer()"
          ></b-form-select>
        </b-col>
        <b-col class="ml-auto col-sm-12 col-md-6 col-lg-6 mb-3">
          <b-form-group>
            <b-form-input
              class="form-control-sm"
              id="filter-input"
              v-model="filter.search"
              type="search"
              :placeholder="$t('search')"
              @input="debouncedGetAnswer()"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="12" class="table-responsive">
          <b-table
            class="align-items-center table-flush tablesorter table-text"
            hover
            :items="getTranfersPending.data"
            :fields="columns"
            :per-page="getTranfersPending.per_page"
            :busy="
              !Array.isArray(getTranfersPending.data) ||
              getTranfersPending.data.length === 0
                ? true
                : false
            "
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <span class="h2 text-danger">{{ $t("fail") }}</span>
              </div>
            </template>
            <template v-slot:cell(name)="data">
              {{ data.item.name }} {{ data.item.lastname }}
            </template>
            <template v-slot:cell(amount)="data">
              {{ data.item.amount }} MC
            </template>
            <template v-slot:cell(wallet)="data">
              <b-link
                v-if="data.item.wallet"
                size="sm"
                v-clipboard:copy="data.item.wallet"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >
                {{ data.item.wallet }}
                <i class="far fa-copy"></i>
              </b-link>
              <span v-else></span>
            </template>
            <template v-slot:cell(created_at)="data">
              {{ moment(data.item.created_at).format("DD-MM-YYYY H:m") }} hrs.
            </template>
            <template v-slot:cell(status)="data">
              <b-badge
                class="text-white"
                size="lg"
                style="font-size: 10px"
                :class="colorStatus(data.item.status)"
              >
                {{ nameStatus(data.item.status) }}
              </b-badge>
            </template>
            <template v-slot:cell(action)="data">
              <b-button
                v-if="data.item.status == 1"
                v-b-tooltip.hover
                :title="$t('process')"
                variant="success"
                size="sm"
                @click="processTransfers({ status: 2, id: data.item.id })"
                ><i class="ri-check-line"></i
              ></b-button>
              <b-button
                v-if="data.item.status == 1"
                v-b-tooltip.hover
                :title="$t('reject')"
                variant="danger"
                size="sm"
                @click="processTransfers({ status: 3, id: data.item.id })"
                ><i class="ri-close-line"></i
              ></b-button>
            </template>
          </b-table>
          <b-pagination
            class="mt-3"
            v-model="getTranfersPending.current_page"
            :total-rows="getTranfersPending.total"
            :per-page="getTranfersPending.per_page"
            :page-count="getTranfersPending.per_page"
            @input="changePage"
            first-number
            pills
            size="sm"
            align="center"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </b-overlay>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import helpers from "../../../services/helpers";
import moment from "moment";
export default {
  props: {
    title: String,
  },
  async created() {
    this.debouncedGetAnswer = _.debounce(this.loadData, 200);
    await this.loadData();
  },
  data() {
    return {
      filter: {
        page: 1,
        per_page: 5,
        search: null,
      },
      moment,
    };
  },
  methods: {
    ...mapActions({
      getTransfersPending: "transfersPending",
      actionsTransfers: "actionsTransfers",
    }),
    async loadData() {
      await this.getTransfersPending(this.filter);
    },
    async changePage(value) {
      this.filter.page = value;
      await this.debouncedGetAnswer();
    },
    onCopy(err) {
      this.$toast.success(this.$t("message-copy-wallet-success"), {
        position: "top-right",
      });
    },
    onError(e) {
      this.$toast.error(this.$t("message-copy-wallet-fail"), {
        position: "top-right",
      });
    },
    async processTransfers(data) {
      try {
        if (
          await helpers.showMsgConfirm({
            tittle: "are_you_sure?",
            msg:
              data.status == 2
                ? "question_process_transfers"
                : "question_reject_transfers",
          })
        ) {
          const res = await this.actionsTransfers(data);
          if (res.status === 200) {
            this.$toast.success(res.message, {
              position: "top-right",
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    colorStatus(status) {
      let color;
      switch (status) {
        case "1":
          color = "bg-info";
          break;
        case "2":
          color = "bg-success";
          break;
        case "3":
          color = "bg-danger";
          break;
      }
      return color;
    },
    nameStatus(status) {
      let name;
      switch (status) {
        case "1":
          name = this.$t("pending");
          break;
        case "2":
          name = this.$t("processed");
          break;
        case "3":
          name = this.$t("rejected");
          break;
      }
      return name;
    },
  },
  computed: {
    ...mapGetters({
      getTranfersPending: "getTranfersPending",
      usersLoading: "usersLoading",
    }),
    columns() {
      return [
        { label: this.$t("name"), key: "name", class: "text-center" },
        { label: this.$t("wallet"), key: "wallet", class: "text-center" },
        { label: this.$t("concept"), key: "concept", class: "text-center" },
        { label: this.$t("amount"), key: "amount", class: "text-center" },
        { label: this.$t("date"), key: "created_at", class: "text-center" },
        { label: this.$t("status"), key: "status", class: "text-center" },
        { label: this.$t("action"), key: "action", class: "text-center" },
      ];
    },
  },
};
</script>
